import api from './base.api';
import type { AxiosRequestConfig } from 'axios';
import type {
  EncryptionKey,
  ExchangeEncryptionKey,
} from '@/interfaces/encryption.interface';

const BASE_PATH = '/encryption';

export const getEncryptionKey = async () => {
  return api.post<EncryptionKey>(`${BASE_PATH}/keys`);
};

export const getExchangeEncryptionKey = async () => {
  return api.post<ExchangeEncryptionKey>(
    `${BASE_PATH}/generate-exchange-key`,
  );
};

export const exchangeEncryptionKey = async (
  exchangeKey: string,
  config?: AxiosRequestConfig,
) => {
  return api.post<EncryptionKey>(`${BASE_PATH}/exchange`, exchangeKey, config);
};
